export const FirebaseConfig = {
	"projectId": "sride-777",
	"appId": "1:506464832665:web:c3dc184613fc63d9107c08",
	"databaseURL": "https://sride-777-default-rtdb.firebaseio.com",
	"storageBucket": "sride-777.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyB02AE7Z7Djt1i7EDXIJpQRqtdMoHz4KFA",
	"authDomain": "sride-777.firebaseapp.com",
	"messagingSenderId": "506464832665",
	"measurementId": "G-KP6N0VV7EB",
	"projectNumber": "506464832665",
	"version": "2"
};